// extracted by mini-css-extract-plugin
export default {"InsightsScreen":"InsightsMobile_InsightsScreen__yitZd","mb8":"InsightsMobile_mb8__TLqzC","mb16":"InsightsMobile_mb16__NIdOg","BottomTab":"InsightsMobile_BottomTab__YDNLb"};